<template>
  <v-card class="my-4">
    <v-card-title class="px-6 pb-0">
      <v-row>
        <v-col cols="8">
          <span class="section-title">Histórico de solicitações</span>
          <p class="section-subtitle pt-1">
            Essa tabela mostra o histórico de todas as solicitações realizadas por consumidores, junto com os respostas dadas pelos usuários da plataforma.
          </p>
        </v-col>
        <v-col cols="4">
          <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Buscar pelo CPF/CNPJ" />
        </v-col>
      </v-row>
    </v-card-title>

    <paginated-data-table
      ref="table"
      :headers="headers"
      :search="search"
      :query="query"
      queryName="usersAllDeleteDataRequests"
      :queryVariables="queryVariables"
      item-key="_id"
      @update-options="updateVariables"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.document_no | cpfCnpj }}
          </td>
          <td>
            {{ item.delete_data_request.data | hifen }}
          </td>
          <td>
            {{ item.delete_data_request.requested_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm' }) }}
          </td>
          <td>
            {{ item.delete_data_request.finished_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm' }) }}
          </td>
          <td>
            <a v-if="item.delete_data_request.status === 'Reprovada'" class="info--text" @click="openDeclinedRequestModal(item)">{{
              item.delete_data_request.status
            }}</a>
            <span v-else>{{ item.delete_data_request.status }}</span>
          </td>
          <td>
            {{ item.delete_data_request.finished_by | hifen }}
          </td>
        </tr>
      </template>
    </paginated-data-table>

    <declined-request-modal
      :status-declined-request-modal.sync="statusDeclinedRequestModal"
      :selectedRequest="selectedRequest"
      @updateTable="updateTable"
      @closeDeclinedRequestModal="closeDeclinedRequestModal"
    />
  </v-card>
</template>

<script>
import { QUERY_GET_USERS_ALL_DELETE_DATA_REQUESTS } from '@/modules/clientes/gerenciamento/graphql'
import DeclinedRequestModal from '@/modules/clientes/gerenciamento/views/components/DeclinedRequestModal.vue'

export default {
  name: 'UsersDeleteDataRequestsHistoryTable',

  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    DeclinedRequestModal,
  },

  data() {
    return {
      search: '',
      selectedRequest: {
        name: '',
        document_no: '',
        delete_data_request: {
          data: [],
          requested_at: '',
          finished_at: '',
          status: '',
          finished_by: '',
          reply: '',
        },
      },
      statusDeclinedRequestModal: false,
      queryVariables: {
        sort: ['delete_data_request.finished_at'],
        sortDirection: ['DESC'],
      },
    }
  },

  computed: {
    query() {
      return QUERY_GET_USERS_ALL_DELETE_DATA_REQUESTS
    },
    headers() {
      return [
        {
          text: 'CPF/CNPJ',
          value: 'document_no',
          width: '16%',
        },
        {
          text: 'Dado solicitado',
          value: 'delete_data_request.data',
          width: '20%',
        },
        {
          text: 'Data da solicitação',
          value: 'delete_data_request.requested_at',
          width: '17%',
        },
        {
          text: 'Data da resposta',
          value: 'delete_data_request.finished_at',
          width: '17%',
        },
        {
          text: 'Resposta',
          value: 'delete_data_request.status',
          width: '15%',
        },
        {
          text: 'Respondido por',
          value: 'delete_data_request.finished_by',
          width: '15%',
        },
      ]
    },
  },

  methods: {
    updateVariables(newQueryOptions) {
      const { sortBy, sortDesc } = newQueryOptions

      if (sortBy.length && sortDesc.length) {
        this.queryVariables.sort = sortBy
        this.queryVariables.sortDirection = sortDesc[0] ? ['DESC'] : ['ASC']
      }
    },

    updateTable() {
      this.$refs.table.waitAndGetData()
    },

    clearSelectedRequest() {
      this.selectedRequest = {
        name: '',
        document_no: '',
        delete_data_request: {
          data: [],
          requested_at: '',
          finished_at: '',
          status: '',
          finished_by: '',
          reply: '',
        },
      }
    },

    openDeclinedRequestModal(request) {
      this.statusDeclinedRequestModal = true
      this.selectedRequest = request
    },

    closeDeclinedRequestModal() {
      this.statusDeclinedRequestModal = false
      this.clearSelectedRequest()
    },
  },
}
</script>

<style lang="scss" scoped>
.section-subtitle {
  @extend .texto-corrido;
  word-break: break-word;
}
</style>
